export const TRANSACTION_STATUS = {
  ACCEPTED_AWAITING_FUNDING: "ACCEPTED_AWAITING_FUNDING"
}
